import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {RouterModule, Routes} from '@angular/router';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {NgSelect2Module} from 'ng-select2';
import {MatStepperModule} from '@angular/material/stepper';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatListModule} from '@angular/material/list';
import {MatIconModule} from '@angular/material/icon';
import {InlineSVGModule} from 'ng-inline-svg';
import {NgbAccordionModule, NgbAlertModule, NgbPaginationModule, NgbRatingModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {ClientsComponent} from './clients.component';
import {ClientsListComponent} from './clients-list/clients-list.component';
import {AddClientComponent} from './add-client/add-client.component';
import {AngularEditorModule} from '@kolkov/angular-editor';
import {EditClientComponent} from './edit-client/edit-client.component';
import {ViewClientComponent} from './view-client/view-client.component';
import {UserRolesGuardsService} from '../../../shared/guards/user-roles-guards.service';
import {SharedModuleModule} from '../../../shared-module/shared-module.module';

const routes: Routes = [
    {
        path: '',
        component: ClientsComponent,
        children: [
            {
                path: 'lista',
                component: ClientsListComponent,
            },
            {
                path: 'adaugare',
                component: AddClientComponent,
            },
            {
                path: 'vizualizare/:id',
                component: ViewClientComponent
            },
            {
                path: 'editare/:id',
                component: EditClientComponent
            },
            { path: '', redirectTo: '/', pathMatch: 'full' },
            {
                path: '**',
                redirectTo: '/',
                pathMatch: 'full',
            }
        ],
    },
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        FormsModule,
        NgSelect2Module,
        MatStepperModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatListModule,
        MatIconModule,
        InlineSVGModule,
        NgbAlertModule,
        NgbTooltipModule,
        NgbPaginationModule,
        NgbAccordionModule,
        AngularEditorModule,
        NgbRatingModule,
        SharedModuleModule,
    ],
    declarations: [ClientsComponent,
        ClientsListComponent,
        AddClientComponent,
        ViewClientComponent,
        EditClientComponent]

})
export class ClientsModule { }
